import './Translator';
import Vue from "vue";
import Permission from "./Permission";
import * as PermissionString from "./../Config/PermissionString";

const permission = new Permission();

Vue.prototype.$have = ability => {
    if (!PermissionString[ability]) {
        console.warn(`Please add ${ability} in PermissionString.js file`);
        return permission.can(ability);
    }
    return permission.can(PermissionString[ability]);
};

Vue.prototype.$isSuperAdmin = () => permission.isAppAdmin();
Vue.prototype.$isAppAdmin   = () => permission.isAppAdmin();
Vue.prototype.$isWebAdmin   = () => permission.isWebAdmin();